import { SecLoansReferenceRate } from '@shared/sec-loans'
import { FieldName } from 'react-hook-form'
import { IntlShape } from 'react-intl'
import { create, enforce, only, Suite, test } from 'vest'

import { ReferenceRateInfoFormData as FormData } from './types'

export const createFormValidator = (
  formatMessage: IntlShape['formatMessage'],
): Suite<string, string, (data: FormData, changedFields?: FieldName<FormData>[]) => void> => {
  return create((data, changedFields) => {
    only(changedFields)

    test('referenceRate', formatMessage({ id: 'validate-required-field-missing' }), () => {
      enforce(data.referenceRate).inside(Object.values(SecLoansReferenceRate))
    })
  })
}
